import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { IconGeneratorForm } from '../components/IconGeneratorForm';
import { IconPreview } from '../components/IconPreview';
import { useIconGenerator } from '../hooks/useIconGenerator';

export function IconGeneratorPage() {
  const { status, previewUrl, error, generate, save, reset } = useIconGenerator();

  return (
    <div className="p-6 max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Icon Generator</h1>
        <p className="text-muted-foreground mt-1">
          Generate professional app-store-style icons with AI
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Icon Details</CardTitle>
        </CardHeader>
        <CardContent>
          <IconGeneratorForm status={status} onGenerate={generate} onSave={save} onReset={reset} />
        </CardContent>
      </Card>

      <IconPreview status={status} previewUrl={previewUrl} error={error} />
    </div>
  );
}
